import { Drawer } from 'components/Drawer'
import { Heading } from 'blaze-ui/Heading/Heading'
import { observer } from 'mobx-react-lite'
import { DrawerProps } from 'components/Drawer/Root'
import { CreditsPopoverContent } from './CreditsPopover'

interface Props extends DrawerProps {
  onSuccess?: () => void
  totalSocialCount: number
  totalBlogCount: number
  totalEmailCount: number
  totalShortFormVideoCount: number
  monthlyCredits: number
  isGrowthPlan: boolean
  blogCountCreditsNeeded: number
  emailCountCreditsNeeded: number
  socialCountCreditsNeeded: number
  shortFormVideoCountCreditsNeeded: number
  stillImageCount?: number
  carouselCount?: number
  feedVideoCount?: number
  stillImageCreditsNeeded?: number
  carouselCreditsNeeded?: number
  feedVideoCreditsNeeded?: number
}

export const CreditsBreakdownDrawer = observer(
  ({
    totalSocialCount,
    totalBlogCount,
    totalEmailCount,
    totalShortFormVideoCount,
    monthlyCredits,
    isGrowthPlan,
    blogCountCreditsNeeded,
    emailCountCreditsNeeded,
    socialCountCreditsNeeded,
    shortFormVideoCountCreditsNeeded,
    stillImageCount,
    carouselCount,
    feedVideoCount,
    stillImageCreditsNeeded,
    carouselCreditsNeeded,
    feedVideoCreditsNeeded,
    onSuccess,
    ...props
  }: Props) => {
    return (
      <Drawer.Root {...props}>
        <Drawer.Portal>
          <Drawer.Overlay />
          <Drawer.Content>
            <Drawer.InnerContent>
              <Drawer.Top>
                <div />
                <Drawer.Title asChild>
                  <Heading level={5}>Credits breakdown</Heading>
                </Drawer.Title>
                <Drawer.Close variant="ghost" position="right" label="Close" />
              </Drawer.Top>
              <Drawer.Container>
                <CreditsPopoverContent
                  blogCountCreditsNeeded={blogCountCreditsNeeded}
                  emailCountCreditsNeeded={emailCountCreditsNeeded}
                  socialCountCreditsNeeded={socialCountCreditsNeeded}
                  shortFormVideoCountCreditsNeeded={shortFormVideoCountCreditsNeeded}
                  totalSocialCount={totalSocialCount}
                  totalBlogCount={totalBlogCount}
                  totalEmailCount={totalEmailCount}
                  totalShortFormVideoCount={totalShortFormVideoCount}
                  monthlyCredits={monthlyCredits}
                  isGrowthPlan={isGrowthPlan}
                  stillImageCount={stillImageCount}
                  carouselCount={carouselCount}
                  feedVideoCount={feedVideoCount}
                  stillImageCreditsNeeded={stillImageCreditsNeeded}
                  carouselCreditsNeeded={carouselCreditsNeeded}
                  feedVideoCreditsNeeded={feedVideoCreditsNeeded}
                />
              </Drawer.Container>
            </Drawer.InnerContent>
          </Drawer.Content>
          <Drawer.Overlay />
        </Drawer.Portal>
      </Drawer.Root>
    )
  },
)
